import SpousalSupportSummary from "./components/SpousalSupportSummary";
import CreateSpousalSupportOrderButton from "../../components/CreateSpousalSupportOrderButton";
import { useSpousalSupportOrder } from "../../contexts/SpousalSupportOrderContext";
import SpousalSupportPaymentsList from "./components/SpousalSupportPaymentsList/SpousalSupportPaymentsList";
import SpousalSupportCurrentOrder from "./components/SpousalSupportCurrentOrder";
import ErrorView from "../../components/ErrorView";
import LoadingView from "../../components/LoadingView";
import NoMatterView from "../../components/NoMatterView";
import { useMatter } from "../../contexts/MatterContext";
import { Heading } from "../../design/heading";
import SpousalSupportUpsellCard from "./components/SpousalSupportUpsellCard";

const SpousalSupportPage = () => {
  const { currentMatterId, currentMatter } = useMatter();
  const { loading, error } = useSpousalSupportOrder();

  if (loading.list) {
    return <LoadingView title="Loading Spousal Support Orders" />;
  }

  if (error.list) {
    return <ErrorView error={error.list} />;
  }

  return (
    <div>
      {!currentMatter?.unlockedFeatures?.includes(
        "spousal_support_tracker",
      ) && <SpousalSupportUpsellCard />}
      {currentMatter?.unlockedFeatures?.includes("spousal_support_tracker") && (
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <Heading>Spousal Support</Heading>
            <CreateSpousalSupportOrderButton />
          </div>

          <SpousalSupportSummary />
          <SpousalSupportCurrentOrder />

          <SpousalSupportPaymentsList />
        </div>
      )}
    </div>
  );
};

export default SpousalSupportPage;
